import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRedWarningCloud(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={102}
      height={102}
      fill="none"
      {...props}
    >
      <path
        fill="url(#RedWarningCloud_svg__a)"
        stroke="#FFB7B7"
        strokeWidth={4}
        d="M39.099 6.93C45.67.357 56.329.357 62.9 6.93l1.113 1.112a12.83 12.83 0 0 0 9.072 3.758h.283c9.295 0 16.831 7.536 16.831 16.83v.284a12.83 12.83 0 0 0 3.758 9.072L95.07 39.1c6.573 6.572 6.573 17.23 0 23.802l-1.112 1.113a12.83 12.83 0 0 0-3.758 9.072v.283c0 9.295-7.536 16.831-16.83 16.831h-.284a12.83 12.83 0 0 0-9.072 3.758L62.9 95.07c-6.572 6.573-17.23 6.573-23.802 0l-1.113-1.112a12.83 12.83 0 0 0-9.072-3.758h-.283c-9.295 0-16.831-7.536-16.831-16.83v-.284a12.83 12.83 0 0 0-3.758-9.072L6.93 62.9c-6.573-6.57-6.573-17.229 0-23.8l1.112-1.113a12.83 12.83 0 0 0 3.758-9.072v-.283c0-9.295 7.536-16.831 16.83-16.831h.284a12.83 12.83 0 0 0 9.072-3.758L39.1 6.93Z"
      />
      <g clipPath="url(#RedWarningCloud_svg__b)">
        <path
          fill="#82090F"
          fillRule="evenodd"
          d="M43.985 35.295c2.993-4.938 10.03-4.938 13.023 0l13 21.45c3.155 5.205-.514 11.922-6.511 11.922h-26c-5.998 0-9.666-6.717-6.512-11.921l13-21.45Zm6.515 8.372c.846 0 1.531.7 1.531 1.563v8.333c0 .863-.685 1.562-1.531 1.562s-1.531-.7-1.531-1.562V45.23c0-.863.685-1.563 1.531-1.563m2.042 15.625c0 1.15-.914 2.083-2.042 2.083s-2.042-.932-2.042-2.083c0-1.15.914-2.083 2.042-2.083s2.042.932 2.042 2.083"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <linearGradient
          id="RedWarningCloud_svg__a"
          x1={29.85}
          x2={51}
          y1={4}
          y2={98}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset={1} stopColor="#F7D0D0" />
        </linearGradient>
        <clipPath id="RedWarningCloud_svg__b">
          <path fill="#fff" d="M26 27h49v50H26z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRedWarningCloud);
export default ForwardRef;
